<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card p-0">
      <div class="card-title w-100 m-0">
        <div class="row p-2">
          <div class="col-lg-5 col-12" [ngClass.xl]="'d-flex'" [ngClass.md]="'d-flex'">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control flex-basis-50" autocomplete="off" [(ngModel)]="filter_string" (ngModelChange)="search()" />
            <div [ngClass.xl]="'ml-1 flex-basis-40'" [ngClass.md]="'ml-1 flex-basis-40'" [ngClass.sm]="'my-1'">
              <ng-select [(ngModel)]="filter_status" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" (ngModelChange)="search()" [clearable]="false" (clear)="filter_status = -1">
                <ng-option [value]="-1">
                  <span class="font-small-4 font-weight-normal">{{ "ALL_STATUS" | translate }}</span>
                </ng-option>
                <ng-option *ngFor="let status of statusTransformationLabels; let i = index" [value]="i">
                  <span class="font-small-4 font-weight-normal">{{ status }}</span>
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-lg-7 col-12 text-right">
            <div class="mr-2" [ngClass.xl]="'d-inline-block'" [ngClass.md]="'d-inline-block'" [ngClass.sm]="'d-none'">
              <label class="d-flex align-items-center mb-0"
                >{{ "SHOW" | translate }}
                <select class="form-control ml-075 pr-3" (change)="tableLimit = $any($event).target.value">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <a routerLink="/dashboard/transformation-select" class="btn btn-outline-primary" *ngIf="_authenticationService.hasCapability('create_transformation')">{{ "ADD" | translate }}</a>
          </div>
        </div>
      </div>

      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 80 : 180"
          [limit]="tableLimit"
          [footerHeight]="30"
          [rows]="filtered_list"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
        >
          <ngx-datatable-column [name]="'TITLES.USERS_TYPES_SINGULAR.collaborator' | translate" prop="user.complete_name" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="row.user.type_code !== 'employee' ? '/dashboard/collaborators/edit/' + row.user.hash : '/dashboard/user/profile/' + row.user.hash" target="_blank">{{ row.user.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TYPE' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ (row.user.type_code === "stage" ? "INTERN" : row.user.type_code === "occasional" ? "OCCASIONAL_PERFORMANCE" : "VAT_NUMBER") | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATE' | translate" prop="status" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge" [ngClass]="{ 'badge-light-secondary': row.status == 0, 'badge-light-success': row.status == 1, 'badge-light-danger': row.status == 2 }">{{
                statusTransformationLabels[row.status]
              }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATUS_DOCUMENTS' | translate" prop="status_document" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-light-{{ statusDocument[row.status_document === null ? 0 : row.status_document].color }}">{{ statusDocument[row.status_document].label | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATUS_CONTRACT' | translate" prop="status_contract" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-light-{{ statusContract[row.status_contract === null ? 0 : row.status_contract].color }}">{{ statusContract[row.status_contract].label | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div ngbDropdown container="body">
                <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                  <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                </button>
                <div ngbDropdownMenu>
                  <a *ngIf="row.status == 2" class="text-success" ngbDropdownItem (click)="restoreTransformation(row.id)"> <i [data-feather]="'plus'" size="16" class="mr-50"></i> {{ "ENABLED" | translate }} </a>
                  <a *ngIf="(row.status_document === 0 || row.status_document === null) && row.status !== 2" (click)="requestDocumentMasterData(row)" ngbDropdownItem>
                    <i [data-feather]="'send'" size="16" class="mr-50"></i> {{ "SEND_REQUEST_DOCUMENT" | translate }}
                  </a>
                  <a *ngIf="(row.status_contract === 0 || row.status_contract === null) && row.status_document === 3 && row.status !== 2" (click)="requestDocumentContract(row)" ngbDropdownItem>
                    <span [data-feather]="'file-text'" size="16" class="mr-50"></span> {{ "SEND_CONTRACT" | translate }}
                  </a>
                  <a ngbDropdownItem [routerLink]="'/dashboard/transformation-edit/' + row.id"> <span [data-feather]="'eye'" size="16" class="mr-50"></span> {{ "VIEW" | translate }} </a>
                  <a ngbDropdownItem *ngIf="row.status == 0 && _authenticationService.hasCapability('edit_transformation')" [routerLink]="'/dashboard/transformation-edit/' + row.id">
                    <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }}
                  </a>
                  <a ngbDropdownItem class="text-danger" (click)="deleteTransformation(row.id)" *ngIf="_authenticationService.hasCapability('delete_transformation')">
                    <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }}
                  </a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'TRANSFORMATION' | translate" prop="user.complete_name" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-10">
                  <div>
                    <a [routerLink]="row.user.type_code !== 'employee' ? '/dashboard/collaborators/edit/' + row.user.hash : '/dashboard/user/profile/' + row.user.hash" target="_blank">{{ row.user.complete_name }}</a>
                  </div>
                  <div>
                    <span>{{ (row.user.type_code === "stage" ? "INTERN" : row.user.type_code === "occasional" ? "OCCASIONAL_PERFORMANCE" : "VAT_NUMBER") | translate }}</span>
                  </div>
                </div>
                <div class="col-2">
                  <div ngbDropdown container="body">
                    <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                      <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                    </button>
                    <div ngbDropdownMenu>
                      <a *ngIf="row.status == 2" class="text-success" ngbDropdownItem (click)="restoreTransformation(row.id)"> <i [data-feather]="'plus'" size="16" class="mr-50"></i> {{ "ENABLED" | translate }} </a>
                      <a *ngIf="(row.status_document === 0 || row.status_document === null) && row.status !== 2" (click)="requestDocumentMasterData(row)" ngbDropdownItem>
                        <i [data-feather]="'send'" size="16" class="mr-50"></i> {{ "SEND_REQUEST_DOCUMENT" | translate }}
                      </a>
                      <a *ngIf="(row.status_contract === 0 || row.status_contract === null) && row.status_document === 3 && row.status !== 2" (click)="requestDocumentContract(row)" ngbDropdownItem>
                        <span [data-feather]="'file-text'" size="16" class="mr-50"></span> {{ "SEND_CONTRACT" | translate }}
                      </a>
                      <a ngbDropdownItem [routerLink]="'/dashboard/transformation-edit/' + row.id"> <span [data-feather]="'eye'" size="16" class="mr-50"></span> {{ "VIEW" | translate }} </a>
                      <a ngbDropdownItem [routerLink]="'/dashboard/transformation-edit/' + row.id"> <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }} </a>
                      <a ngbDropdownItem class="text-danger" (click)="deleteTransformation(row.id)"> <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }} </a>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-075">
                  <!-- statusTransformation-->
                  <div>
                    {{ "STATUS_TRANSFORMATION" | translate }}:
                    <span class="badge" [ngClass]="{ 'badge-light-secondary': row.status == 0, 'badge-light-success': row.status == 1, 'badge-light-danger': row.status == 2 }">{{
                      statusTransformationLabels[row.status]
                    }}</span>
                  </div>
                  <!-- statusDocument-->
                  <div>
                    {{ "STATUS_DOCUMENTS" | translate }}:
                    <span class="badge badge-light-{{ statusDocument[row.status_document === null ? 0 : row.status_document].color }}">{{ statusDocument[row.status_document].label | translate }}</span>
                  </div>
                  <!-- statusContract-->
                  <div>
                    {{ "STATUS_CONTRACT" | translate }}:
                    <span class="badge badge-light-{{ statusContract[row.status_contract === null ? 0 : row.status_contract].color }}">{{ statusContract[row.status_contract].label | translate }}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
